import React from 'react'
import PropTypes from 'prop-types'
import { localsMessages } from '../utility/getTemplateData'
import { StyleSheet, css } from '../utility/paypalAphrodite';
import { Button } from '@paypalcorp/pp-react';

const STYLES = StyleSheet.create({
	wrapper: {
		marginTop: 30,
		marginBottom: 22,
	},
	havePPLabel: {
		marginRight: 5,
		fontSize: 15
	}
});

class PayPalLogIn extends React.Component {
	constructor() {
		super();
	}

	render () {
		const guestMessages = localsMessages('common/pPLogIn') || {}
		const havePPLabel = guestMessages.label && guestMessages.label.havePP || ''
		const logInLabel = guestMessages.label && guestMessages.label.logIn || ''

		return (
			<div className={`row text-center ${css(STYLES.wrapper)}`}>
				<span className={css(STYLES.havePPLabel)}>{havePPLabel}</span>
				<Button
					size="sm"
					id="payWithPP"
					onClick={this.props.handleLogIn}
				>{logInLabel}
				</Button>
			</div>
		);
	}
}

PayPalLogIn.propTypes = {
	label: PropTypes.string,
	handleLogIn: PropTypes.func
};

export default PayPalLogIn
